import React from "react";
import Jabardast from "../../../../assets/svgs/gameplay/Jabardast";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

const JabardastAnimation = () => {

  return (
    <CommonAnimation>
      <Jabardast width={getWidth(148)} height={getWidth(50)} />
    </CommonAnimation>
  );
};

export default JabardastAnimation;
